import {NgModule} from '@angular/core';
import {TranslationPipe} from './translation.pipe';
import {SafePipe} from './safe.pipe';

@NgModule({
  declarations: [TranslationPipe, SafePipe],
  exports: [
    TranslationPipe,
    SafePipe,
  ]
})
export class PipesModule {
}
